import { useState } from "react";
import * as Unicons from '@iconscout/react-unicons';
import { ModalUsuarioDetalhe } from "../Modal/userdetalhe";
import { ModalUsuarioEditar } from "../Modal/usereditar";
import { ModalUsuarioBloquear }from '../Modal/userbloquear';

interface Props{
  item:string[],
  clase?:string
}

export const Itemusuario = (props:Props) => {

  const {item, clase} = props;

  const [isOpen, setIsOpen] = useState(false);
  const onChangeModal = () => {
    if(isOpen===true){
      setIsOpen(false)
    }else{
      setIsOpen(true)
    }
  }
  const onClose = () => {
    setIsOpen(false)
  }

  const [isOpen1, setIsOpen1] = useState(false);
  const onChangeModal1 = () => {
    if(isOpen===true){
      setIsOpen1(false)
    }else{
      setIsOpen1(true)
    }
  }
  const onClose1 = () => {
    setIsOpen1(false)
  }

  const [isOpen2, setIsOpen2] = useState(false);
  const onChangeModal2 = () => {
    if(isOpen===true){
      setIsOpen2(false)
    }else{
      setIsOpen2(true)
    }
  }
  const onClose2 = () => {
    setIsOpen1(false)
  }

  return (
    <>
      <div className={`${clase} flex flex-row justify-strat align-center`}>
        <div className="item w-10 flex flex-row justify-start align-center">
          <Unicons.UilPen style={{cursor:'pointer',marginLeft:10,marginRight:30}} onClick={onChangeModal1} size="20" color="var(--cinza-azulado-500)" />
          <div className="circle-cinza flex flex-row justify-center align-center">
            <Unicons.UilUser style={{cursor:'pointer'}} onClick={onChangeModal2} size="20" color="var(--cinza-azulado-500)" />
          </div>
        </div>
        <div className="item w-25 flex align-center" onClick={onChangeModal}>
          <span>{item[0]}</span>
        </div>
        <div className="item w-15 flex align-center" onClick={onChangeModal}>
          <span>{item[1]}</span>
        </div>
        <div className="item w-10 flex align-center" onClick={onChangeModal}>
          <span>{item[2]} </span>
        </div>
        <div className="item w-15 flex align-center" onClick={onChangeModal}>
          <span>{item[3]} </span>
        </div>
        <div className="item w-10 flex align-center" onClick={onChangeModal}>
          <span>{item[4]} usuários</span>
        </div>
        <div className="item w-15 flex align-center" onClick={onChangeModal}>
          <span>{item[5]} </span>
        </div>
      </div>
      <ModalUsuarioDetalhe
        open={isOpen}
        onClose={onClose}
      />
      <ModalUsuarioEditar
        open={isOpen1}
        onClose={onClose1}
      />
      <ModalUsuarioBloquear
        open={isOpen2}
        onClose={onClose2}
        status="Bloquear usuário"
        text="Deseja mesmo bloquear as permissões e acesso desse usuário?"
        link="usuarios"
      />
    </>
  )
}
